import React from 'react';
import Header from '../2Layout/Header';
import Footer from '../2Layout/Footer';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <div className="rbt-header-sticky rbt-header-transpernt-active active-light-mode">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default MainLayout;
